/** 内部业务入口允许管理员和销售员；这里只决定前端可见性，不能替代服务端角色鉴权。 */
export function isBusinessRole(identifier: unknown): boolean {
  return typeof identifier === 'string' && ['admin', 'sale'].includes(identifier.trim())
}
